// Danele Nonga — reveal, sticky header, deal countdown, mobile drawer, teaser slider.
// Natives Scrollen, keine Bibliotheken.
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  var header = document.getElementById('dn-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Tagesangebot: Countdown bis Mitternacht (Zeitzone des Besuchers)
  var timerEl = document.querySelector('.dn-deal__timer');
  if (timerEl) {
    var label = timerEl.getAttribute('data-label') || 'endet in';
    var tick = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var pad = function (n) { return String(n).padStart(2, '0'); };
      timerEl.textContent = label + ' ' + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  var menu = document.querySelector('[data-menu]');
  if (menu) {
    var scrim = document.querySelector('[data-menu-scrim]');
    var burger = document.querySelector('[data-menu-open]');
    var closeBtn = menu.querySelector('[data-menu-close]');

    var openMenu = function () {
      menu.hidden = false; scrim.hidden = false;
      void menu.offsetWidth;                       // Reflow, sonst greift die Transition nicht
      menu.classList.add('is-open'); scrim.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    };
    var closeMenu = function () {
      menu.classList.remove('is-open'); scrim.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      burger.focus();
      setTimeout(function () {
        if (!menu.classList.contains('is-open')) { menu.hidden = true; scrim.hidden = true; }
      }, 280);
    };

    burger.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    scrim.addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
    matchMedia('(min-width: 769px)').addEventListener('change', function (e) {
      if (e.matches && menu.classList.contains('is-open')) closeMenu();
    });
  }

  var slider = document.querySelector('[data-slider]');
  if (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.dn-slide'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dots] button'));
    if (slides.length) {
      var i = 0, auto = null;
      var DELAY = parseInt(slider.getAttribute('data-delay'), 10) || 6000;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      var show = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var active = k === i;
          s.classList.toggle('is-active', active);
          if (active) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', ''); }
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      };
      var next = function () { show(i + 1); };
      var prev = function () { show(i - 1); };
      var start = function () { if (!reduce && slides.length > 1 && !auto) auto = setInterval(next, DELAY); };
      var stop = function () { if (auto) { clearInterval(auto); auto = null; } };
      var restart = function () { stop(); start(); };

      var nextBtn = slider.querySelector('[data-next]');
      var prevBtn = slider.querySelector('[data-prev]');
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(+d.getAttribute('data-go')); restart(); });
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      var x0 = null;
      slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { (dx < 0 ? next : prev)(); restart(); }
        x0 = null;
      }, { passive: true });

      start();
    }
  }

  // ----- Sofortvorschläge im Suchfeld -----
  var searchForm = document.querySelector('[data-search]');
  if (searchForm) {
    var field = searchForm.querySelector('[data-search-input]');
    var panel = searchForm.querySelector('[data-search-results]');
    var timer = null, lastTerm = '', controller = null;

    var close = function () {
      panel.hidden = true;
      panel.innerHTML = '';
      field.setAttribute('aria-expanded', 'false');
      lastTerm = '';
    };

    var render = function (html) {
      panel.innerHTML = html;
      var empty = panel.textContent.trim() === '';
      panel.hidden = empty;
      field.setAttribute('aria-expanded', empty ? 'false' : 'true');
    };

    var lookup = function (term) {
      if (controller) controller.abort();      // alte Anfrage verwerfen, sonst überholt sie die neue
      controller = new AbortController();
      var url = '/search/suggest?section_id=dn-predictive'
        + '&q=' + encodeURIComponent(term)
        + '&resources[type]=product,collection'
        + '&resources[limit]=6';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(render)
        .catch(function () { /* abgebrochen oder offline: Panel bleibt wie es ist */ });
    };

    field.addEventListener('input', function () {
      var term = field.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { close(); return; }
      if (term === lastTerm) return;
      lastTerm = term;
      timer = setTimeout(function () { lookup(term); }, 220);
    });

    field.addEventListener('focus', function () {
      if (field.value.trim().length >= 2 && panel.innerHTML === '') lookup(field.value.trim());
    });

    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target)) close();
    });
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); field.blur(); }
    });
    searchForm.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = Array.prototype.slice.call(panel.querySelectorAll('[data-ps-item]'));
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (next < 0) { field.focus(); return; }
      (items[next] || items[0]).focus();
    });
  }
})();
